import { PlusIcon } from '@heroicons/react/24/outline';
import { GQLOrderFragment } from '@theprintbar/graphql';
import { capitalise, getFullName, getReadableDate, getReadableTime } from '@theprintbar/shared';
import { Card, EditCell, OutlineLinkButton, Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../../components';

interface OrderNotesProps {
	order: GQLOrderFragment;
	staff?: boolean;
}

export function OrderNotes({ order, staff }: OrderNotesProps) {
	const filterNotes = staff ? order.notes : order.notes?.filter(note => note.customerCanView);
	const sortNotesDesc = filterNotes?.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
	return (
		<div className="text-xs lg:text-sm space-y-2">
			<Card>
				<div className="flex items-center justify-between mb-2 ">
					<h5 className="uppercase">Order Notes</h5>
					{staff && (
						<OutlineLinkButton to="./note" icon={PlusIcon}>
							Add a note
						</OutlineLinkButton>
					)}
				</div>
				<Table>
					<TableHead>
						<TableRow>
							<TableHeader>Time</TableHeader>
							<TableHeader>Date</TableHeader>
							<TableHeader>From</TableHeader>
							<TableHeader>To</TableHeader>
							<TableHeader centered>Note</TableHeader>
							<TableHeader centered>Attachments</TableHeader>
							<TableHeader></TableHeader>
						</TableRow>
					</TableHead>
					<TableBody>
						{sortNotesDesc?.map(note => {
							return (
								<TableRow key={note.id}>
									<TableCell className="w-16">{getReadableTime(note.createdAt)}</TableCell>
									<TableCell className="w-40">{getReadableDate(note.createdAt)}</TableCell>
									<TableCell className="w-40">{note.user ? getFullName(note.user) : 'Customer'}</TableCell>
									<TableCell className="w-40">{capitalise(note.to)}</TableCell>
									<TableCell centered>{note.note}</TableCell>
									<TableCell centered className="flex flex-col">
										{note.attachments?.map(attachment => {
											return (
												<a
													key={attachment.id}
													href={attachment.file?.url}
													target="_blank"
													rel="noreferrer"
													className="text-blue font-bold underline"
												>
													{attachment.name}
												</a>
											);
										})}
									</TableCell>
									<EditCell to={`./note?id=${note.id}`} />
								</TableRow>
							);
						})}
						{!sortNotesDesc?.length && (
							<TableRow>
								<TableCell colSpan={3} className="text-lg text-grey">
									No Notes found...
								</TableCell>
							</TableRow>
						)}
					</TableBody>
				</Table>
			</Card>
		</div>
	);
}
